import React from "react";
import { createRoot } from "react-dom/client";
import GoodsListItem from "./GoodsListItem";
import { useWidgetProps } from "../use-widget-props";

function App() {
  // useWidgetProps로 toolOutput 데이터 읽기 (fallback 데이터 포함)
  const widgetProps = useWidgetProps(() => ({
    goodsList: [],
    qicResult: null,
  }));

  const goodsList = widgetProps?.goodsList || [];
  const qicResult = widgetProps?.qicResult || null;
  const [isLoading, setIsLoading] = React.useState(true);

  //   // 디버깅용 로그
  //   React.useEffect(() => {
  //     console.log("[goods-list] widgetProps:", widgetProps);
  //     console.log("[goods-list] goodsList:", goodsList);
  //     console.log("[goods-list] goodsList.length:", goodsList.length);
  //   }, [widgetProps, goodsList]);

  React.useEffect(() => {
    // goodsList가 로드되면 로딩 종료
    if (goodsList && goodsList.length > 0) {
      setIsLoading(false);
    }

    // 5초 후에도 데이터가 없으면 로딩 종료 (타임아웃)
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [goodsList]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-gray-100"></div>
      </div>
    );
  }

  if (!goodsList || goodsList.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500 dark:text-gray-400">
        검색 결과가 없습니다.
      </div>
    );
  }

  // qicResult가 있고, 최소 하나의 값이라도 비어있지 않은지 확인
  const hasQicData =
    qicResult &&
    ((qicResult.category && qicResult.category.trim()) ||
      (qicResult.brand_name && qicResult.brand_name.trim()) ||
      (qicResult.maker_name && qicResult.maker_name.trim()));

  return (
    <div className="container mx-auto px-4 py-6">
      {/* QIC 결과 표시 */}
      {hasQicData && (
        <div className="mb-6">
          <div className="rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 p-4">
            <div className="flex items-start gap-3">
              <div className="shrink-0 w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">
                  검색 분석 결과
                </h3>
                <div className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
                  {qicResult.category && qicResult.category.trim() && (
                    <div>
                      <span className="font-medium">카테고리:</span>{" "}
                      {qicResult.category}
                    </div>
                  )}
                  {qicResult.brand_name && qicResult.brand_name.trim() && (
                    <div>
                      <span className="font-medium">브랜드:</span>{" "}
                      {qicResult.brand_name}
                    </div>
                  )}
                  {qicResult.maker_name && qicResult.maker_name.trim() && (
                    <div>
                      <span className="font-medium">제조사:</span>{" "}
                      {qicResult.maker_name}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 리스트 컨테이너 */}
      <div className="space-y-4">
        {goodsList.map((goods, index) => (
          <GoodsListItem key={goods.product_id || index} goods={goods} />
        ))}
      </div>

      {/* 총 개수 표시 */}
      <div className="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
        총 {goodsList.length}개의 상품
      </div>
    </div>
  );
}

createRoot(document.getElementById("goods-list-root")).render(<App />);
